import { FC } from "react";

import { TranslateParamsType, TranslateTextKeyType } from "../hooks/translator";
import { useTranslate } from "../hooks/useTranslate";

interface Props {
  textKey: TranslateTextKeyType;
  params?: TranslateParamsType;
  children?: (text: string) => string;
  allowHtml?: boolean;
  concat?: string;
}

const Translated: FC<Props> = ({
  textKey,
  params,
  children,
  allowHtml,
  concat,
}) => {
  const translate = useTranslate();

  let text = children
    ? children(translate(textKey, params))
    : translate(textKey, params);

  if (concat) {
    text = text.concat(concat);
  }

  return allowHtml ? (
    <span dangerouslySetInnerHTML={{ __html: text }} />
  ) : (
    <>{text}</>
  );
};

export default Translated;
